<template>
  <div
    id="hubspotForm"
    class="app"
  >
    <SideHelpComponent
      class="chat-help"
      :show-side-panel="ShowSideHelpComponent"
      width="425px"
      :height="`calc(100vh - var(--px${headerHeight}))`"
      @close="ShowSideHelpComponent = false"
    />
    <div
      v-if="addBankSuggestion"
      class="fy-app-sn-wrap text-gray"
    >
      <div class="fy-app-sn-close clickable">
        <FontAwesomeIcon
          icon="times"
          @click="addBankSuggestion = false"
        />
      </div>
      <div class="fy-app-sn-text translate">
        Banque connectée avec succès !<br />
        Avez-vous une autre banque à connecter ?
      </div>
      <div class="fy-app-sn-controls">
        <div
          class="clickable text-blue translate"
          @click="
            showAddBankPopup();
            addBankSuggestion = false;
          "
        >
          Ajouter une autre banque
        </div>
      </div>
    </div>
    <UnlockFeaturePopup
      v-if="showFeaturePopup"
      style="z-index: 221"
      @close="showFeaturePopup = false"
      @unlock="
        showUpgradePopup = v0Required;
        showUpgradeV1Popup = !v0Required;
        showFeaturePopup = false;
      "
    />
    <UpgradePlanPopup
      v-if="showUpgradePopup && basePlan"
      style="z-index: 221"
      :base-plan="basePlan"
      @close="showUpgradePopup = false"
      @confirm="
        confirmUpgrade();
        showUpgradePopup = false;
      "
    />
    <UpgradePlanV1Popup
      v-if="showUpgradeV1Popup && basePlan"
      style="z-index: 221"
      :base-plan="basePlan"
      @close="showUpgradeV1Popup = false"
      @confirm="confirmUpgrade"
    />
    <AddUserPopup
      v-if="addingUser && !mobile"
      :base-plan="basePlan"
      :company-id="addingUser.companyId"
      :employees="addingUser.employees"
      @close="addingUser = null"
      @update="updateUsersTable"
    />
    <AddUsersMobileFrame
      v-else-if="addingUser"
      :base-plan="basePlan"
      :company-id="addingUser.companyId"
      :employees="addingUser.employees"
      @close="addingUser = null"
      @update="updateUsersTable"
    />
    <AddBankPopup
      v-if="addBankPopupDisplayed && !mobile"
      style="z-index: 192"
      :bank-and-aggregators="bankAndAggregators"
      @close="addBankPopupDisplayed = false"
    />
    <AddBanksMobileFrame
      v-else-if="addBankPopupDisplayed"
      :bank-and-aggregators="bankAndAggregators"
      @close="addBankPopupDisplayed = false"
    />
    <SubscriptionLimitPopup
      v-if="!!additionalUpdateData"
      :update-data="additionalUpdateData"
      :loading="updatingSubscription"
      @close="additionalUpdateData = null"
      @confirm="updateAdditionalSubscriptions"
    />
    <AdBlockPopup
      v-if="adBlockEnabled"
      @close="closeAdBlocker"
    />
    <CpaTrialPopup
      v-if="cpaTrialLimit"
      @close="cpaTrialLimit = false"
    />
    <SigninPopup v-if="signinPopup" />
    <DefaultMobileFrame
      v-if="mobile && creatingCompany"
      ref="addcmp"
      title="AJOUTER UNE ENTREPRISE"
      back-button
      @close="
        creatingCompany = false;
        dmfInput = '';
        companySiret = '';
        wrongLength = false;
      "
    >
      <div class="fy-app-dmf-container">
        <FygrInput
          v-model="dmfInput"
          class="fy-app-dmf-container-input"
          label="Entreprise"
          placeholder="Ex : Nouvelle entreprise"
          :spellcheck="false"
          :value-in="dmfInput"
          autofocus
          no-prompt
        />
        <FygrInput
          v-if="cpaCompany"
          v-model="companySiret"
          class="fy-app-dmf-container-input"
          invalid-prompt="SIRET invalide."
          label="SIRET"
          placeholder="Ex : 12345678900000"
          :invalid="wrongLength"
          :spellcheck="false"
          :value-in="companySiret"
          :validate="wrongLength"
          @input="wrongLength = false"
        />
        <div class="fy-app-dmf-container-controls">
          <FygrButton
            class="fy-app-dmf-container-confirm"
            color="green"
            :disabled="
              !dmfInput ||
              (cpaCompany && !companySiret) ||
              wrongLength ||
              isCreatingCompany
            "
            :loading="isCreatingCompany"
            @fygr-click="
              createNewCompany({companyName: dmfInput, companySiret})
            "
          >
            Créer l'entreprise
          </FygrButton>
        </div>
      </div>
    </DefaultMobileFrame>
    <CreatingCompanyPopup
      v-else-if="creatingCompany"
      :button-disabled="wrongLength"
      :button-loading="isCreatingCompany"
      @close="
        creatingCompany = false;
        cpaCompany = null;
      "
      @confirmed="createNewCompany"
    />
    <DeleteConfirmationPopup
      v-if="(popupConfirmDeleteCompany && authorized) || deletingCompany"
      :deleting="deletingCompany"
      @close="popupConfirmDeleteCompany = false"
      @confirmed="confirmDeleteCompany"
    >
      Confirmer cette action entraînera la suppression de ce compte entreprise.
      Cette action est irréversible.
    </DeleteConfirmationPopup>
    <DefaultMobileFrame
      v-if="mobile && popupConfirmDeleteBank && authorized"
      ref="delbank"
      title="ÊTES-VOUS SUR ?"
      @close="
        popupConfirmDeleteBank = false;
        dmfInput = '';
      "
    >
      <div class="fy-app-dmf-container">
        <div class="fy-app-dmf-container-text translate">
          La suppression de cette banque entraînera I'effacement de toutes Ies
          données dans la base de données Fygr. Cette action est irréversible.
        </div>
        <div class="fy-app-dmf-container-text translate">
          La catégorisation des transactions contenues dans les comptes de cette
          banque sera perdue. En cas d'ajout à nouveau de cette banque par la
          suite, la plupart des organismes bancaires ne fourniront qu'un nombre
          limité de mois d'historique ce qui limitera Ia performance des
          algorithmes Fygr pendant quelques temps
        </div>
        <FygrInput
          v-model="dmfInput"
          class="fy-app-dmf-container-input"
          :label="`Entrer ${supprimerTranslated} pour confirmer`"
          :placeholder="supprimerTranslated"
          :spellcheck="false"
          :value-in="dmfInput"
          no-prompt
        />
        <div class="fy-app-dmf-container-controls">
          <FygrButton
            class="fy-app-dmf-container-confirm"
            color="red"
            :disabled="dmfInput !== supprimerTranslated || deletingBank"
            :loading="deletingBank"
            @fygr-click="confirmDeleteBank"
          >
            Supprimer
          </FygrButton>
          <a
            class="fy-app-dmf-container-cancel clickable translate"
            @click="$refs.delbank.close()"
          >
            Annuler
          </a>
        </div>
      </div>
    </DefaultMobileFrame>
    <DeleteConfirmationPopup
      v-else-if="popupConfirmDeleteBank && authorized"
      :deleting="deletingBank"
      @close="popupConfirmDeleteBank = false"
      @confirmed="confirmDeleteBank"
    >
      La suppression de cette banque entraînera I'effacement de toutes Ies
      données dans la base de données Fygr. Cette action est irréversible.
      <br /><br />
      La catégorisation des transactions contenues dans les comptes de cette
      banque sera perdue. En cas d'ajout à nouveau de cette banque par la suite,
      la plupart des organismes bancaires ne fourniront qu'un nombre limité de
      mois d'historique ce qui limitera Ia performance des algorithmes Fygr
      pendant quelques temps
    </DeleteConfirmationPopup>
    <DeleteConfirmationPopup
      v-if="showDeleteIntegration"
      :deleting="deletingIntegration"
      @close="
        showDeleteIntegration = false;
        partnerToDelete = null;
      "
      @confirmed="deleteIntegration"
    >
      La suppression de cette intégration empêchera la synchronisation des
      données entre Fygr et
      <span class="deleting-partner-name">{{
        partnerToDelete.partner_name
      }}</span>
      à l'avenir. Les données stockées sur Fygr ne seront pas supprimées.
    </DeleteConfirmationPopup>
    <!--    <TooManyConnectionsPopup-->
    <!--      v-if="tooManyConnections"-->
    <!--      :max="customMax || maxConnections"-->
    <!--      :type="customType"-->
    <!--      @close="-->
    <!--        actionSetTooManyConnections(false);-->
    <!--        customMax = 0;-->
    <!--        customType = 'bank';-->
    <!--        isUser = true;-->
    <!--      "-->
    <!--      @confirmed="-->
    <!--        (e) => {-->
    <!--          actionConnectionsRequest(e);-->
    <!--          isUser = true;-->
    <!--          actionSetTooManyConnections(false);-->
    <!--        }-->
    <!--      "-->
    <!--    />-->
    <div
      v-if="loading"
      class="global-spinner"
    >
      <Spinner />
      <div
        v-if="loadingTitle"
        class="loading-title text-upper-big translate"
      >
        {{ loadingTitle }}
      </div>
    </div>
    <div
      v-if="notifications.length"
      class="notifications translate"
      :style="
        notifications[0]?.bottomSpace !== undefined
          ? {bottom: `${notifications[0]?.bottomSpace}px`}
          : {}
      "
    >
      <div
        v-for="(n, i) in notifications"
        :key="`not-${i}`"
        :class="[`${n.color || 'gray'}-bg`, `${n.textPosition || 'centered'}`]"
        class="notification"
      >
        {{ n.msg || '' }}
        <FontAwesomeIcon
          class="close-notification-icon"
          icon="times"
          @click="() => actionRemoveNotification(n)"
        />
      </div>
    </div>
    <div
      v-if="
        (generalLoader && authorized && !finishedAuth) ||
        (!authorized &&
          (!checkNotAuthenticatedPages($route.name) ||
            checkCallbackPages($route.name)) &&
          !checkOauthNotAuthenticated($route.name))
      "
      class="general-spinner"
    >
      <Spinner
        type="big"
        style="margin: 15px auto"
      />
      <span class="text-blue-slim translate">Chargement en cours</span>
    </div>
    <component
      :is="layout"
      v-show="
        !generalLoader ||
        (!authorized &&
          (checkNotAuthenticatedPages($route.name) ||
            checkOauthNotAuthenticated($route.name)))
      "
      :mobile="mobile || null"
      :show-create-company="showCreateCompany"
      :show-confirm-delete-bank="showConfirmDeleteBank"
      :show-confirm-delete-company="showConfirmDeleteCompany"
      :show-confirm-delete-integration="showConfirmDeletePartnerIntegration"
      @show-add-bank-popup="showAddBankPopup"
    >
      <router-view
        v-if="mayBeCreated && !hideApp && (!authorized || finishedAuth)"
        v-slot="{Component}"
        :key="keyHolder"
        :mobile="mobile || null"
        @additional-update="
          basePlan = $event;
          additionalUpdateData = $event;
        "
        @add-user="addUser"
        @create-company="showCreateCompany"
        @show-add-bank-popup="showAddBankPopup"
        @show-add-bank-suggestion="showAddBankSuggestion"
        @show-confirm-delete-bank="showConfirmDeleteBank"
        @show-confirm-delete-integration="showConfirmDeletePartnerIntegration"
        @unlock-feature="
          basePlan = $event;
          showFeaturePopup = true;
        "
        @unlock="
          basePlan = $event;
          showUpgradePopup = true;
        "
        @unlock-v1="
          basePlan = $event;
          showUpgradeV1Popup = true;
        "
        @show-hub-spot-help="ShowSideHelpComponent = true"
      >
        <component
          :is="Component"
          ref="view"
        />
      </router-view>
      <div
        v-else-if="hideApp"
        class="trial-expired-mngd container"
        :style="{margin: `calc(50vh - 250px) auto`}"
      >
        <LuPlaceholder>
          <div class="lu-text-trial text-gray">
            Le service a été suspendu pour cette entreprise.<br /><br />
            Vous pouvez vous rapprocher de l'utilisateur
            <a :href="`mailto:${ownerEmail}`">{{ ownerEmail }}</a> pour plus
            d'informations.
          </div>
        </LuPlaceholder>
      </div>
      <div
        v-if="
          checkRouteAllowedShowBanner(inAppMessage) &&
          inAppMessage &&
          inAppMessage.is_active &&
          !inAppMessage.is_shown
        "
        class="fy-app-in-app-message translate"
      >
        <Markdown
          class="fy-app-md-container"
          :source="mdHTML"
        />
        <FontAwesomeIcon
          class="fy-app-in-app-message-close clickable"
          icon="times"
          @click="actionHideInAppMessage()"
        />
      </div>
    </component>
    <OnboardingLayout
      v-if="!hideApp && !mobile && !hideOnboardingButton"
      v-show="(authorized || chapters.length === 1) && !generalLoader"
      :msg-txt="
        !!mdHTML &&
        checkRouteAllowedShowBanner(inAppMessage) &&
        inAppMessage &&
        inAppMessage.is_active &&
        !inAppMessage.is_shown &&
        mayBeCreated &&
        !hideApp &&
        (!generalLoader ||
          (!authorized &&
            (checkNotAuthenticatedPages($route.name) ||
              checkOauthNotAuthenticated($route.name))))
      "
      @show-add-bank-popup="showAddBankPopup"
    />
    <TrialLayout
      v-show="!generalLoader"
      :finish="finishSubscription"
      :mobile="mobile || null"
    />
    <FygrInteractiveNotification
      v-if="showReloadNotification"
      primary-text="Mettre à jour"
      secondary-text="Plus tard"
      @close="showReloadNotification = false"
      @primary="clearCache(true)"
      @secondary="showReloadNotification = false"
    >
      <span class="translate">
        Une mise à jour de l'application est disponible. Cette mise à jour sera
        instantanée.</span
      >
    </FygrInteractiveNotification>
  </div>
</template>

<script>
import {defineAsyncComponent, nextTick} from 'vue';
import {mapActions, mapGetters, mapState} from 'vuex';
import {companyMixin} from '@/mixins/companyMixin';
import {StripeMixin} from '@/mixins/StripeMixin';
import {cpaMixin} from '@/mixins/cpaMixin';
import {mobileMixin} from '@/mixins/mobileMixin';
import {pagesChecker} from '@/mixins/pagesCheckerMixin';
import {paywallMixin} from '@/mixins/paywallMixin';
import {appMixin} from '@/mixins/appMixin';
import {checkUpdatesMixin} from '@/mixins/checkUpdatesMixin';
import AppBus from '@/bus/app-bus';
import {SUPPRIMERTRANSLATED} from '@/data/locales';

const defaultLayout = 'default';

export default {
  name: 'App',
  components: {
    FygrInteractiveNotification: defineAsyncComponent(
      () => import('@/components/elements/FygrInteractiveNotification.vue'),
    ),
    Markdown: defineAsyncComponent(
      () => import('@/components/elements/MarkDown.vue'),
    ),
    AdBlockPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AdBlockPopup.vue'),
    ),
    AddBankPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AddBankPopup.vue'),
    ),
    AddBanksMobileFrame: defineAsyncComponent(
      () => import('@/components/elements/AddBanksMobileFrame.vue'),
    ),
    AddUsersMobileFrame: defineAsyncComponent(
      () => import('@/components/elements/AddUsersMobileFrame.vue'),
    ),
    DefaultMobileFrame: defineAsyncComponent(
      () => import('@/components/elements/DefaultMobileFrame.vue'),
    ),
    AddUserPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/AddUserPopup.vue'),
    ),
    SubscriptionLimitPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/SubscriptionLimitPopup.vue'),
    ),
    CpaTrialPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/CpaTrialPopup.vue'),
    ),
    CreatingCompanyPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/CreatingCompanyPopup.vue'),
    ),
    DeleteConfirmationPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/DeleteConfirmationPopup.vue'),
    ),
    OnboardingLayout: defineAsyncComponent(
      () => import('@/components/layouts/OnboardingLayout.vue'),
    ),
    SigninPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/SigninPopup.vue'),
    ),
    // TooManyConnectionsPopup: defineAsyncComponent(
    //   () => import('@/components/elements/popups/TooManyConnectionsPopup.vue'),
    // ), TODO remove after 01.10.25 if not needed
    TrialLayout: defineAsyncComponent(
      () => import('@/components/layouts/trial-layout.vue'),
    ),
    UnlockFeaturePopup: defineAsyncComponent(
      () => import('@/components/elements/popups/UnlockFeaturePopup.vue'),
    ),
    UpgradePlanPopup: defineAsyncComponent(
      () => import('@/components/elements/popups/UpgradePlanPopup.vue'),
    ),
    UpgradePlanV1Popup: defineAsyncComponent(
      () => import('@/components/elements/popups/UpgradePlanV1Popup.vue'),
    ),
    SideHelpComponent: defineAsyncComponent(
      () => import('@/components/elements/SideHelpComponent.vue'),
    ),
    DefaultLayout: defineAsyncComponent(
      () => import('@/components/layouts/DefaultLayout.vue'),
    ),
  },
  mixins: [
    companyMixin,
    cpaMixin,
    mobileMixin,
    pagesChecker,
    paywallMixin,
    appMixin,
    StripeMixin,
    checkUpdatesMixin,
  ],
  data() {
    return {
      additionalUpdateData: null,
      headerHeight: 75,
      ShowSideHelpComponent: false,
      addBankSuggestion: false,
      addBankPopupDisplayed: false,
      addingUser: null,
      bankAndAggregators: [],
      popupConfirmDeleteCompany: false,
      deletingCompany: false,
      popupConfirmDeleteBank: false,
      deletingBank: false,
      idToDelete: null,
      isUser: true,
      mobile: false,
      customType: 'bank',
      adBlockEnabled: false,
      creatingCompany: false,
      isCreatingCompany: false,
      cpaCompany: null,
      cpaTrialLimit: false,
      wrongLength: false,
      mayBeCreated: false,
      basePlan: null,
      showFeaturePopup: false,
      showUpgradePopup: false,
      showUpgradeV1Popup: false,
      updatingSubscription: false,
      dmfInput: '',
      companySiret: '',
      finishedAuth: false,
      deletingIntegration: false,
      showDeleteIntegration: false,
      partnerToDelete: null,
    };
  },
  computed: {
    ...mapGetters('bank', ['bankNumber']),
    ...mapGetters('user', ['activeUser', 'getLocale']),
    ...mapState('app', [
      'chapters',
      'globalLoading',
      'loading',
      'loadingTitle',
      'notifications',
      'tou',
      'inAppMessage',
    ]),
    ...mapState('bank', ['banks']),
    ...mapState('company', ['stylesLoaded']),
    ...mapState('partner', ['partnerIntegrationVisibility']),
    ...mapState('user', [
      'authorized',
      'companiesLoaded',
      'user',
      'maxConnections',
      'companies',
      'isStandalone',
      'isCompanyCpa',
      'signinPopup',
      'isAdBlockerDetected',
    ]),
    ...mapState('subscription', ['subscription', 'managedTrial', 'showTrial']),
    supprimerTranslated() {
      return SUPPRIMERTRANSLATED[this.getLocale.toUpperCase()];
    },
    mdHTML() {
      return this.inAppMessage.body || '';
    },
    v0Required() {
      return !this.subscription.free_trial_version || !this.subscription.trial;
    },
    generalLoader() {
      return this.globalLoading || !this.stylesLoaded || !this.companiesLoaded;
    },
    hideApp() {
      return (
        !this.subscription.has_subscription &&
        !this.subscription.trial &&
        !this.isStandalone &&
        !this.isCpaUser(this.activeUser) &&
        !this.loading &&
        Object.entries(this.subscription).length &&
        !this.subscription.default
      );
    },
    hideOnboardingButton() {
      const routeName = this.$route?.name;
      return (
        routeName?.includes('onboarding') ||
        routeName?.includes('personal-infos') ||
        routeName?.includes('company-infos') ||
        (routeName?.includes('transactions') &&
          localStorage.getItem('FYGR_SHOW_TRANSACTIONS_ONBOARDING') &&
          this.bankNumber)
      );
    },
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
    keyHolder() {
      return `${this.$route.fullPath}`;
    },
    ownerEmail() {
      if (!Object.entries(this.companies).length) {
        return '';
      }
      const id = localStorage.getItem('FYGR_COMPANY');
      return this.companies[id][1];
    },
    validBanks() {
      return this.banks.filter((b) => b.aggregator);
    },
  },
  watch: {
    async authorized(nv) {
      if (nv) {
        this.loadSponsorhip();
        await this.actionGetBanksAndAccountsList();
        await this.actionGetPermissions();
        await this.actionGetDefaultCurrency();
        await this.actionGetUserProfile();
        await this.actionGetMaxConnections();
        await this.actionGetMaxCategoryDepth();
        await this.actionGetCompaniesList();
        await this.actionGetCompanyInfo(localStorage.getItem('FYGR_COMPANY'));
        await this.actionSetMasterCookie();
        setTimeout(() => this.loadStripeScript(), 2000);
        this.finishedAuth = true;
      } else {
        this.finishedAuth = false;
        await this.actionUnauthBanks();
        this.actionUnauthApp();
      }
    },
    companies: {
      handler() {
        if (this.companies && this.isCpaUser(this.activeUser)) {
          const companyId = localStorage.getItem('FYGR_COMPANY');
          const cpaId = this.companies[companyId]
            ? this.companies[companyId][2]
            : companyId;
          this.actionGetTrialCpaChildren({companyId: cpaId});
        }
      },
      deep: true,
    },
    getLocale: {
      handler() {
        this.loadSponsorhip();
      },
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScaleAndZoom);
  },
  created() {
    document.body.classList.add('body-opacity-1'); // temporary unflicker solution (TT-3944)
  },
  async beforeMount() {
    await this.init();
    this.mayBeCreated = true;
  },
  async mounted() {
    this.mobile = this.mobileDevicesRegex.some((mdr) =>
      navigator.userAgent.match(mdr),
    );
    this.checkScaleAndZoom();
    await this.actionDetectAdBlocker();
    setTimeout(async () => {
      if (!localStorage.getItem('AD_BLOCKER_WARNING_SEEN')) {
        this.adBlockEnabled = this.isAdBlockerDetected;
      }
    }, 2000);
    AppBus.$on('unlock', (e) => {
      this.basePlan = e;
      this.showUpgradePopup = true;
    });
    AppBus.$on('unlockV1', (e) => {
      this.basePlan = e;
      this.showUpgradeV1Popup = true;
    });

    setTimeout(() => {
      const sug = localStorage.getItem('addBankSuggestion');
      if (sug) {
        localStorage.removeItem('addBankSuggestion');
        if (this.banks.length) {
          this.showAddBankSuggestion();
        }
      }
    }, 3000);
    window.addEventListener('load', () => {
      this.headerHeight =
        document.getElementById('nav') &&
        document.getElementById('nav').clientHeight
          ? document.getElementById('nav').clientHeight
          : 75;
    });
    window.addEventListener('resize', this.checkScaleAndZoom);
    setTimeout(() => {
      document.body.classList.remove('body-opacity-1');
    }, 8000); // temporary unflicker solution (TT-3944)
  },
  updated() {
    nextTick(() => {
      if (this.mobile && window.Intercom) {
        window.Intercom('update', {
          hide_default_launcher: true,
        });
      }
    });
  },
  methods: {
    ...mapActions('app', [
      'actionSetAppLoaded',
      'actionAddNotification',
      'actionRemoveNotification',
      'actionGetTou',
      'actionUnauthApp',
      'actionSetScalingCoeff',
      'actionHideInAppMessage',
    ]),
    ...mapActions('bank', [
      'actionGetBanksAndAccountsList',
      'actionDeleteConnection',
      'actionUnauthBanks',
      'actionSetMasterCookie',
    ]),
    ...mapActions('billing', [
      'actionGetCurrentBasePlan',
      'actionUpdateSubscription',
    ]),
    ...mapActions('user', [
      'actionInitUser',
      'actionGetUserProfile',
      'actionGetEmployeeList',
      'actionConnectionsRequest',
      'actionGetDefaultCurrency',
      'actionGetCompaniesList',
      'actionCreateCompany',
      'actionGetMaxConnections',
      'actionGetMaxCategoryDepth',
      'actionGetPermissions',
      'actionDeleteCompany',
      'actionFinishSignup',
      'actionUpdateCompany',
      'actionDetectAdBlocker',
      'actionInitSponsorhip',
      'actionGetCompanyInfo',
    ]),
    ...mapActions('provider', ['actionGetBanksAndAggreagtors']),
    ...mapActions('subscription', [
      'actionGetSubscriptionForCompany',
      'actionChangeShowTrial',
      'actionChangeShowTrialButton',
      'actionGetTrialCpaChildren',
      'actionRemoveFromManagedTrial',
    ]),
    ...mapActions('partner', ['actionDeletePartnerIntegration']),
    checkScaleAndZoom() {
      const firefox = navigator.userAgent.match(/firefox|fxios/i);
      const macos = navigator.userAgent.match(/mac/i);
      if (!this.mobile) {
        this.actionSetScalingCoeff({
          dpr: firefox || macos ? 1 : window.devicePixelRatio,
          zoom: Math.round((window.innerWidth / window.outerWidth) * 100),
        });
      }
    },
    loadSponsorhip() {
      if (false && this.getLocale === 'fr') {
        this.actionInitSponsorhip();
      }
    },
    closeAdBlocker() {
      this.adBlockEnabled = false;
      localStorage.setItem('AD_BLOCKER_WARNING_SEEN', true);
    },
    async deleteIntegration() {
      this.deletingIntegration = true;
      await this.actionDeletePartnerIntegration({
        partner_id: this.partnerToDelete.partner_id,
        partner_integration_id: this.partnerToDelete.partner_integration_id,
      });
      localStorage.removeItem('FYGR_CURRENT_SELECTED_PARTNER');
      this.deletingIntegration = false;
      this.showDeleteIntegration = false;
      window.location.reload();
    },
    showAddBankSuggestion() {
      this.addBankSuggestion = true;
      if (this.showTrial && this.subscription.free_trial_version) {
        localStorage.setItem('addBankSuggestion', true);
      }
    },
    checkRouteAllowedShowBanner(inAppMessage) {
      if (!inAppMessage.routes || inAppMessage.routes.length === 0) {
        return true;
      }
      let res = false;
      inAppMessage.routes.forEach((item) => {
        if (item === this.$route.path) {
          res = true;
        }
        // if (item.includes('*') && this.$route.matched[0]
        //   && this.$route.matched[0].path === (item.replace(/\*/g, ''))) {
        //   res = true;
        // }
      });
      return res;
    },
    async addUser(e) {
      const companyId = localStorage.getItem('FYGR_COMPANY');
      this.basePlan = await this.actionGetCurrentBasePlan({companyId});
      let {employees} = e;
      if (!employees) {
        const res = await this.actionGetEmployeeList({
          companyId: e.companyId,
          getAll: this.isCompanyCpa,
        });
        employees = res.users;
      }
      this.addingUser = {...e, employees};
    },
    confirmUpgrade() {
      this.showUpgradePopup = false;
      this.showUpgradeV1Popup = false;
      if (this.basePlan.type === 'bank') {
        this.showAddBankPopup();
      } else if (this.basePlan.type === 'user') {
        this.$refs.view.addUser();
      }
      AppBus.$emit('updateBasePlan');
    },
    async updateAdditionalSubscriptions() {
      this.updatingSubscription = true;
      const companyId = localStorage.getItem('FYGR_COMPANY');
      const event = this.basePlan.updateEvent;
      await this.actionUpdateSubscription({
        companyId,
        events: {...event, plans: this.basePlan.current_base_plan},
        from_event: true,
      })
        .then(async () => {
          await this.actionGetSubscriptionForCompany();
          AppBus.$emit('updateSubscriptionVar');
          this.actionAddNotification({
            msg: 'Votre abonnement a bien été modifié',
            color: 'green',
            disappearing: true,
            once: true,
          });
          this.basePlan = null;
        })
        .catch((err) => {
          if (err.message === 'Could not create a new customer on Stripe.') {
            this.actionAddNotification({
              msg: 'Veuillez commencer par remplir les informations de facturation.',
              color: 'red',
              disappearing: true,
              once: true,
            });
          } else {
            this.actionAddNotification({
              msg: "Échec de l'application du plan sélectionné",
              color: 'red',
              once: true,
            });
          }
        })
        .finally(() => {
          this.updatingSubscription = false;
          this.additionalUpdateData = null;
        });
    },
    updateUsersTable() {
      if (this.$refs.view.updateUsersTable) {
        this.$refs.view.updateUsersTable();
      }
    },
    async showAddBankPopup() {
      const companyId = localStorage.getItem('FYGR_COMPANY');
      this.basePlan = await this.actionGetCurrentBasePlan({companyId}).catch(
        () => {
          this.actionAddNotification({
            msg:
              'Erreur lors de la récupération des données BasePlan. ' +
              'Si le problème persiste, veuillez contacter le support',
            color: 'red',
            disappearing: true,
            once: true,
          });
        },
      );
      if (this.maxConnections <= this.validBanks.length) {
        this.isUser = false;
        this.$router.push({name: 'book-a-meeting'});
        return;
      }
      if (this.checkLimits('bank')) {
        return;
      }
      if (this.banks) {
        this.addBankPopupDisplayed = true;
        return;
      }
      throw new Error(
        `ShowAddBankPopup no branch executed. this.banks=${this.banks?.length}, this.checkLimits=${this.checkLimits('bank')}, this.maxConnections= ${this.maxConnections}`,
      );
    },
    showCreateCompany() {
      if (this.isCpaUser(this.activeUser) && this.managedTrial.length >= 2) {
        this.cpaTrialLimit = true;
        return;
      }
      let companyId = localStorage.getItem('FYGR_COMPANY');
      if (this.companies[companyId] && this.companies[companyId][2]) {
        [, , companyId] = this.companies[companyId];
      }
      this.cpaCompany = this.isCpaUser(this.activeUser) ? companyId : null;
      this.creatingCompany = true;
    },
    showConfirmDeleteBank(id) {
      this.idToDelete = id;
      this.popupConfirmDeleteBank = true;
    },
    showConfirmDeletePartnerIntegration(partnerIntegration) {
      this.partnerToDelete = partnerIntegration;
      this.idToDelete = partnerIntegration.partner_id;
      this.showDeleteIntegration = true;
    },
    showConfirmDeleteCompany(id) {
      this.idToDelete = id;
      this.popupConfirmDeleteCompany = true;
    },
    async finishSubscription() {
      await this.actionGetSubscriptionForCompany();
      this.actionChangeShowTrial(false);
      this.actionChangeShowTrialButton(false);
    },
    async init() {
      const companyId = localStorage.getItem('FYGR_COMPANY');
      const accessToken = localStorage.getItem('FYGR_ACCESS_TOKEN');
      // getting TOU for signup
      if (!this.tou) {
        await this.actionGetTou();
      }
      if (companyId && accessToken) {
        await this.actionInitUser();
        this.actionSetAppLoaded(true);
      }
    },
    async confirmDeleteCompany() {
      this.deletingCompany = true;
      const res = await this.actionDeleteCompany({id: this.idToDelete});
      if (res && (res.error || res.status_code === 401)) {
        this.actionAddNotification({
          msg:
            'Une erreur est survenue lors de la suppression de la company. ' +
            'Un email a été envoyé avec les données à support@fygr.io',
          color: 'red',
          disappearing: true,
          once: true,
        });
        this.deletingCompany = false;
        return;
      }
      const currentCompanyId = localStorage.getItem('FYGR_COMPANY');
      if (currentCompanyId === this.idToDelete) {
        let companyList = await this.actionGetCompaniesList();
        companyList = Object.keys(companyList);
        this.switchCompany(companyList[0] || '', false, 'dashboard');
      } else {
        this.popupConfirmDeleteCompany = false;
        this.idToDelete = null;
        this.deletingCompany = false;
      }
    },
    async confirmDeleteBank() {
      this.deletingBank = true;
      await this.actionDeleteConnection(this.idToDelete).catch(() => {
        this.actionAddNotification({
          msg:
            "Votre banque n'a pas pu être supprimée. Une alerte a été envoyée à " +
            'support@fygr.io qui régularisera la situation dans les plus brefs délais.',
          color: 'red',
          disappearing: true,
          once: true,
        });
      });

      if (this.$refs.view.getBanksMC) {
        await this.$refs.view.getBanksMC({
          id: this.idToDelete.companyId,
          name: this.idToDelete.name,
        });
      }
      this.deletingBank = false;
      this.idToDelete = null;
      this.dmfInput = '';
      if (this.mobile) {
        this.$refs.delbank.close();
      } else {
        this.popupConfirmDeleteBank = false;
      }
    },
    async createNewCompany(dataIn) {
      this.isCreatingCompany = true;
      let processed;
      const {id, res} = await this.actionCreateCompany({
        name: dataIn.general.company.companyName,
        siret: dataIn.general.admin_information.establishment_id,
        parentId: this.cpaCompany ? this.cpaCompany : null,
      }).catch((err) => {
        this.isCreatingCompany = false;
        if (err.message === 'siret_in_use') {
          this.actionAddNotification({
            msg: 'Un dossier avec ce SIRET existe déjà.',
            color: 'red',
            disappearing: true,
            once: true,
          });
        } else {
          this.actionAddNotification({
            msg: 'La création a échoué. Veuillez réessayer.',
            color: 'red',
            disappearing: true,
            once: true,
          });
        }
        processed = false;
      });
      if (processed === false) {
        return false;
      }
      await this.actionUpdateCompany({
        admin_information: dataIn.general.admin_information,
        company: dataIn.general.company,
        customization: {
          onboarding_customization_id: dataIn.customId,
        },
        id,
      });
      this.isCreatingCompany = false;
      this.cpaCompany = null;
      this.creatingCompany = false;
      this.switchCompany(id, this.$route.name, 'dashboard');
    },
  },
};
</script>
<style>
.body-opacity-1 {
  opacity: 1 !important;
}
</style>
<style lang="scss">
@media only screen and (max-width: 500px) {
  #hubspot-messages-iframe-container {
    transform: scale(0);
  }
}
#app {
  height: 100%;
}
.app {
  position: relative;
  height: 100%;
  .fy-app-in-app-message {
    display: flex;
    width: 100%;
    position: relative;
    min-height: var(--px40);
    bottom: 0;
    .fy-app-in-app-message-close {
      position: absolute;
      right: var(--px15);
      top: calc(50% - var(--px8));
      color: #ffffff;
    }
  }
}
.general-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.chat-help {
  position: absolute;
  bottom: 0;
}
.fy-app-finish-signup-wrap {
  &.mobile {
    .fy-app-input {
      width: calc(100% - var(--px2));
    }
    .fy-app-confirm {
      width: 100%;
      font-size: var(--px20);
      max-height: var(--px50);
      min-height: var(--px50);
    }
  }
  .fy-app-input {
    width: var(--px358);
    &.fy-app-phone {
      .info-icon[class] {
        color: $gray;
        margin-bottom: var(--px2);
      }
    }
  }
  .fy-app-confirm {
    width: var(--px360);
    max-height: var(--px40);
    min-height: var(--px40);
    margin-top: var(--px20);
  }
}
.fy-app-dmf-container {
  display: flex;
  flex-direction: column;
  .fy-app-dmf-container-text {
    display: flex;
    margin-bottom: var(--px30);
    font-size: var(--px16);
  }
  .fy-app-dmf-container-input {
    margin-bottom: var(--px15);
    width: 100%;
    font-size: var(--px16);
    .invalid-prompt[class] {
      font-size: var(--px14);
    }
    input[class] {
      font-size: var(--px16);
      max-height: var(--px44);
      min-height: var(--px44);
    }
  }
  .fy-app-dmf-container-controls {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: var(--px16);
    margin-top: var(--px15);
    width: 100%;
    .fy-app-dmf-container-confirm {
      width: 100%;
      font-size: var(--px20);
      margin-bottom: var(--px20);
      font-weight: 500;
      height: var(--px50);
    }
    .fy-app-dmf-container-cancel {
      color: $blue;
      font-size: var(--px18);
      font-weight: 600;
    }
  }
}
.fy-app-md-container {
  width: 100%;
  min-height: var(--px40);
  display: flex;
  align-items: center;
  justify-content: center;
}
.fy-app-in-app-message-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss">
.trial-expired-mngd {
  display: flex;
  width: var(--px500);
  height: var(--px300);
  margin: calc(50vh - var(--px250)) auto;
  .lup-wrapper {
    margin: auto;
    align-items: center;
  }
  .lu-text-trial {
    width: var(--px260);
    text-align: center;
    a {
      text-decoration: none;
    }
  }
}
.global-spinner {
  z-index: 99;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(black, $alpha: 0.5);
  .loading-title {
    color: white;
    position: absolute;
    top: calc(50% + var(--px50));
    user-select: none;
  }
}
.notifications {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
  padding: var(--px5);
  display: flex;
  flex-direction: column;
}

.fy-app-sn-wrap {
  position: fixed;
  bottom: var(--px20);
  right: var(--px20);
  background: #ffffff;
  box-shadow: 0px var(--px4) var(--px4) rgba(0, 0, 0, 0.25);
  border-radius: var(--px8);
  width: var(--px300);
  height: var(--px85);
  z-index: 1;
  padding: var(--px20);
  display: flex;
  flex-direction: column;
  .fy-app-sn-controls {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-top: auto;
  }
  .fy-app-sn-close {
    position: absolute;
    right: var(--px10);
    top: var(--px10);
    color: $gray;
  }
}
.notification {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  width: var(--px250);
  max-width: var(--px250);
  min-height: var(--px50);
  cursor: default;
  border-radius: var(--px10);
  padding: var(--px24) var(--px24) var(--px16) var(--px16);
  color: white;
  margin: var(--px5);
  position: relative;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  &.bottom-space {
    margin-bottom: var(--px110);
  }
  &.gray-bg {
    background-color: rgba($gray, 0.8);
    &:hover {
      background-color: rgba($gray, 0.9);
    }
  }
  &.ebony-bg {
    background-color: rgba($ebony, 0.8);
    &:hover {
      background-color: rgba($ebony, 0.9);
    }
  }
  &.red-bg {
    background-color: rgba($red, 0.8);
    &:hover {
      background-color: rgba($red, 0.9);
    }
  }
  &.green-bg {
    background-color: rgba($green, 0.8);
    &:hover {
      background-color: rgba($green, 0.9);
    }
  }
  &.centered {
    text-align: center;
  }
  &.justified {
    text-align: justify;
  }
  &.left-aligned {
    text-align: left;
  }
  .close-notification-icon {
    cursor: pointer;
    position: absolute;
    top: var(--px16);
    right: var(--px16);
  }
}
</style>
